import moment from 'moment-timezone';
import { WithTranslation } from 'react-i18next';
import { Product, ProductSummary } from 'models/product';

export const getBookingStartDateTimeText = (
  product: Product | ProductSummary | undefined,
  t: WithTranslation['t']
) => {
  const timezone = moment.tz.guess();

  return t('Sorry, this plan will be available from {{startDateTime}}.', {
    startDateTime: moment(product?.agent_guest_booking_period_settings?.booking_start_date_time_utc)
      .tz(product?.start_timezone || timezone)
      .format('YYYY-MM-DD HH:mm'),
  });
};
